import Quill from 'quill-next';

export type Status = 'played' | 'playing' | 'toplay';

const Container = Quill.import('blots/container') as any;

export class ListeningArticleContainerBlock extends Container {
  static blotName = 'listening-article-container';
  static className = 'ql-l-article-container';
  static tagName = 'div';

  public timeStart = 0;
  public timeEnd = 0;
  public order = -1;

  public status: Status = 'toplay';

  static create(value: any) {
    const domNode = super.create(value);

    domNode.dataset.play = 'toplay';

    return domNode;
  }

  optimize(context: { [key: string]: any; }) {
    super.optimize(context);
    // this.domNode.dataset.play = this.status;
    if (this.children && this.children.head && this.children.head.domNode.dataset.timestart && this.children.head.domNode.dataset.timeend) {
      this.timeStart = Number(this.children.head.domNode.dataset.timestart) / 1000;
      this.timeEnd = Number(this.children.head.domNode.dataset.timeend) / 1000;
      this.order = Number(this.children.head.domNode.dataset.order);
    }
  }

  checkMerge() {
    // 同组中英文合并
    if (this.next) {
      if (this.children.length !== 1) {
        return false;
      }
      if (this.children.head.statics.blotName !== 'listening-article-en') {
        return false;
      }
      if (this.next.children.length !== 1) {
        return false;
      }
      if (this.next.children.head.statics.blotName !== 'listening-article-cn') {
        return false;
      }
    }
    return true;
  }

  updateStatus(s: Status) {
    if (s === this.status) {
      return;
    }
    this.status = s;
    this.domNode.dataset.play = s;
    if (s === 'playing') {
      const { top, bottom } = this.domNode.getBoundingClientRect();
      if (top > 200 || bottom < 200) {
        this.scroll.domNode.scrollBy({ top: top - 200, behavior: 'smooth' });
      }
    }
  }

  scrollTo() {
    const { top, bottom } = this.domNode.getBoundingClientRect();
    if (top > 200 || bottom < 200) {
      this.scroll.domNode.scrollBy({ top: top - 200, behavior: 'smooth' });
    }
  }
}

